declare const mqtt: any;

interface MqttClientOptions {
  onMessage?: (json: any) => void;
  onError?: (err: any) => void;
}

export function initMqttClient(
  mqttRoleId: number,
  callbacks: MqttClientOptions = {}
) {
  const mqttServer = import.meta.env.VITE_MQTT_SERVER;
  const options = {
    connectTimeout: import.meta.env.VITE_MQTT_CONNECT_TIMEOUT,
    username: import.meta.env.VITE_MQTT_USERNAME,
    password: import.meta.env.VITE_MQTT_PASSWORD,
    reconnectPeriod: import.meta.env.VITE_MQTT_RECONNECT_PERIOD,
    clean: import.meta.env.VITE_MQTT_CLEAN === "true",
    clientId: `${
      import.meta.env.VITE_MQTT_APPNAME
    }_${mqttRoleId}_${randomString(8)}`,
  };
  const topic = import.meta.env.VITE_MQTT_TOPIC;

  const mqttClient = mqtt.connect(mqttServer, options);

  mqttClient.on("connect", () => {
    console.log("MQTT connected");
    mqttClient.subscribe(topic, (err: any) => {
      if (err) {
        console.error("MQTT subscribe error:", err);
      }
    });
  });

  mqttClient.on("error", (err: any) => {
    console.log("MQTT error:", err);
    callbacks.onError?.(err);
  });

  mqttClient.on("message", (_topic: string, message: any) => {
    try {
      const json = JSON.parse(message);
      console.log("ondata", json);
      callbacks.onMessage?.(json);
    } catch (e) {
      console.warn("JSON parse error", e);
    }
  });

  return mqttClient;
}

function randomString(len: number, charSet?: string): string {
  charSet =
    charSet || "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < len; i++) {
    const randomPoz = Math.floor(Math.random() * charSet.length);
    result += charSet.charAt(randomPoz);
  }
  return result;
}
